import React from 'react';
import dateFormat from 'dateformat';
import { Grid, Typography } from '@mui/material';

const styles = {
  container: {
    margin: 10,
  },
};

function getDescription(result) {
  // 'PERMFEELAT', 'CANCELCSNP', 'CANCELPRNP', 'CSPAIDLATE'
  switch (result) {
    case 'PERMFEELAT':
      return 'Permit Fee has been paid.';
    case 'CANCELCSNP':
      return 'The Compromise and Settlement offer has not been paid.  The Compromise and Settlement offer has been voided and the permit rescinded.';
    case 'CANCELPRNP':
      return 'Permit fee has been rescinded and the permit cancelled.';
    case 'CSPAIDLATE':
      return 'A Compromise and Settlement has been paid.';
    case 'CSVOID':
      return 'The Compromise and Settlement offer has been voided.';
    // return 'Take No Action on Cancellation';
    default:
      return 'Unknown';
  }
}

export default function CancelledOutcome(props) {
  console.log('props:', props);

  return (
    <Grid sx={styles.container}>
      <div>
        <Typography variant='subtitle2' display='inline'>
          PERMITTEE:
        </Typography>
        <span>{` ${props.permit.PERMITTEE}`}</span>
      </div>
      <div>
        <Typography variant='subtitle2' display='inline'>
          PERMIT NO:
        </Typography>
        <span>{` ${props.permit.CASE_NUMBER}`}</span>
      </div>
      <div>
        <Typography variant='subtitle2' display='inline'>
          WELL NO:
        </Typography>
        <span>{` ${props.permit.WELL_NO}`}</span>
      </div>
      <div>
        <Typography variant='subtitle2' display='inline'>
          HEARING:
        </Typography>
        <span>
          {` ${dateFormat(
            props.permit.NEXT_PREV_TARGET_END_DATE,
            'mmmm d, yyyy',
            true
          )}`}
        </span>
      </div>
      <div>
        <Typography variant='subtitle2' display='inline'>
          STATUS:
        </Typography>
        <span>{` ${getDescription(props.permit.PREV_RESULT_CODE)}`}</span>
      </div>
    </Grid>
  );
}
